import type { Editor } from '@tiptap/react';
import { useEditorState } from '@tiptap/react';
import { ALL_BUTTONS, isButtonActive, executeButton } from './toolbarButtons';
import styles from './EditorToolbar.module.css';

interface EditorToolbarProps {
  editor: Editor;
}

export default function EditorToolbar({ editor }: EditorToolbarProps) {
  const activeStates = useEditorState({
    editor,
    selector: ({ editor: e }) =>
      ALL_BUTTONS.reduce(
        (acc, btn) => {
          acc[btn.key] = e ? isButtonActive(e, btn) : false;
          return acc;
        },
        {} as Record<string, boolean>
      ),
  });

  return (
    <div className={styles.toolbar} role="toolbar" aria-label="Text formatting">
      {ALL_BUTTONS.map((button) => {
        const isActive = activeStates?.[button.key] ?? false;

        return (
          <button
            key={button.key}
            type="button"
            tabIndex={-1}
            className={`${styles.button} ${isActive ? styles.active : ''}`}
            onClick={() => executeButton(editor, button)}
            onMouseDown={(e) => e.preventDefault()}
            aria-label={button.label}
            aria-pressed={isActive}
          >
            <button.Icon />
          </button>
        );
      })}
    </div>
  );
}
